import React from "react"

type Props = {
	ref?: React.LegacyRef<SVGSVGElement>
}

const CurveSvg = ({ref}: Props) => {
	return (
		<svg
			ref={ref}
			preserveAspectRatio={"xMinYMin meet"}
			style={{
				position: "relative",
				zIndex: 2,
				top: "0",
				left: "-2px",
				height: "calc(100% + 4px)",
				width: "calc(100% + 4px)",
			}}
			viewBox={"0 0 1943 202"}
			xmlns={"http://www.w3.org/2000/svg"}
		>
			<path
				d={
					"M815.5 0H0.5V202H1946V0H1811.5C1680 0 1559.5 226.5 1285.5 108.5C1077 18.708 995 0 815.5 0Z"
				}
				fill={"white"}
				xmlns={"http://www.w3.org/2000/svg"}
			/>
		</svg>
	)
}

export default CurveSvg
